import { Box, Typography, Grid } from "@mui/material";
import data from "../../Assets/data/teachings.json";

const TeachingSection = () => {
  return (
    <>
      <>
        <Box
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: "2em",
          }}
        >
          <Box
            style={{
              width: "100%",
              background:
                "linear-gradient(180deg, #004C98 0%, rgba(90, 139, 188, 0.646736) 38.69%, rgba(255, 255, 255, 0) 100%)",
            }}
          >
            <Typography
              style={{
                padding: "32px",
                width: "100%",
                justifyContent: "flex-end",
                display: "flex",
                boxSizing: "border-box",
                marginRight: "32px",
              }}
              fontSize="32px"
              fontWeight={600}
            >
              Teaching and Tutorials
            </Typography>
          </Box>
          <Box
            style={{
              maxWidth: "960px",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  fontWeight={600}
                  fontSize="24px"
                  margin="16px 0px 6px"
                >
                  Teaching at HKUST
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {data[0].HKUST.class.map((ust, i) => {
                  return (
                    <Box key={i} style={{ marginBottom: "12px" }}>
                      <Typography fontWeight={500} fontSize="20px">
                        {ust}
                      </Typography>
                    </Box>
                  );
                })}
              </Grid>
              <Grid item xs={12}>
                <Typography
                  fontWeight={600}
                  fontSize="24px"
                  margin="16px 0px 6px"
                >
                  Tutorials at the University of New South Wales (Sydney)
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {data[0]["University of New South Wales (Sydney)"].class.map(
                  (wales, i) => {
                    return (
                      <Box key={i} style={{ marginBottom: "12px" }}>
                        <Typography fontWeight={500} fontSize="20px">
                          {wales}
                        </Typography>
                      </Box>
                    );
                  }
                )}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </>
    </>
  );
};

export default TeachingSection;
